import { combineReducers } from 'redux';
import login from './login';
import user from './user';
import buildings from './buildings';
import equipment from './equipment';
import points from './points';
import devices from './devices';
import ui from './ui';
import equipTypes from './equiptypes';
import pointTypes from './pointtypes';
import tags from './tags';
import labels from './labels';
import series from './timeseries';
import attachments from './attachments';
import users from './users';
import units from './units';
import apiKeys from './apiKeys';
import ingestStats from './ingeststats';
import alerts from './alerts';
import actionLog from './actionLog';
import appVariant from './variant';
import rtemFiles from './rtemFiles';
import rtemSubmissions from './rtemSubmissions';
import measurements from './measurements';
import notificationPreferences from './notificationPreferences';
import unitPrefs from './unitPrefs';
import deployments from './deployments';
import staging from './staging';
import tsExports from './exports';
import dataAlerts from './dataAlerts';
import modbus from './modbus';

const entities = combineReducers({
  buildings,
  equipment,
  equipTypes,
  points,
  pointTypes,
  devices,
  tags,
  labels,
  series,
  attachments,
  units,
  ingestStats,
  alerts,
  measurements,
  notificationPreferences,
  unitPrefs,
  deployments,
  staging,
  tsExports,
  dataAlerts,
  modbus,
});

const combinedReducer = combineReducers({
  login,
  user,
  entities,
  ui,
  users,
  apiKeys,
  actionLog,
  rtemFiles,
  rtemSubmissions,
  appVariant,
});

// the root reducer- essentially the state tree for the entire app
function rootReducer(state = {}, action) {
  return combinedReducer(state, action);
}

export default rootReducer;
